import clsx from 'clsx';
import React from 'react';

import { Newsletter } from '@hooks/useCurrentNewsletter';

import NewsletterSignUp from '../NewsletterSignup';
import styles from './middleStyles.module.scss';

interface MiddleProps {
  currentUserAccessLevel: number;
  isLoggedIn: boolean;
  isSubscribed: boolean;
  gdprColorScheme: string;
  gdpr: boolean;
  newsletter: Newsletter;
}

const Middle = ({
  currentUserAccessLevel,
  isLoggedIn,
  isSubscribed,
  gdprColorScheme,
  gdpr,
  newsletter,
}: MiddleProps) => {
  return (
    <div className={styles.mainContainer} id="feed-newsletter-container-middle">
      <div className={clsx(styles.middleContainer, 'container')}>
        <div className={styles.middleWrapper}>
          <div className={styles.newsletterIntro}>
            <div className={styles.newsletterName}>{newsletter.name} Newsletter</div>
            <div className={styles.newsletterDescription}>{newsletter.description}</div>
          </div>
          <div className={styles.newsletterAction}>
            <NewsletterSignUp
              currentUserAccessLevel={currentUserAccessLevel}
              isLoggedIn={isLoggedIn}
              isSubscribed={isSubscribed}
              gdpr={gdpr}
              gdprColorScheme={gdprColorScheme}
              newsletter={newsletter}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Middle;
